<template>
<div class="block block-themed">
    <div class="col-md-12">

    <div class="content content-boxed">
        <h2 class="block-title">{{sectionLabel[actualLanguage]}}</h2>
        <div class="input-group input-group-lg">
            <input class="form-control" type="text" v-model="stringToFind" placeholder="Rechercher/Search">
            <div class="input-group-btn">
                <button class="btn btn-default"  @click="findElement()"><i class="fa fa-search"></i></button>
            </div>
        </div>

    </div>
    
    
    
    </div>

</div>


</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment';

export default {
  name: 'policyAgreement',

  components: {

  },

  data() {
    return {
        actualLanguage : "FR",
        stringToFind : '',
        searchResult : [],
        NAVTempoGU : [],
        NAVTempoGS : [],

        tempo : '',
        sectionLabel:{ FR: "Recherche d'élément",EN: "Search element"},
        searchLabel: { FR: "Rechercher",EN: "Search"},

    }
  },

computed: {
    ...mapState('sessionStore', ['profileData', 'dashboardFlags', 'groupArborescence', 'navIndex']),
},

  methods: {

    refresh() {
        
        if(localStorage.language){this.actualLanguage =  localStorage.language}
        else{this.actualLanguage = 'FR'}
    },


  findElement(){
      //Structure : 
      //groupArborescence[]
      //-->group_name
      //-->sub_group[]
      //    -->group_name
      //    -->sub_group[]
      //    -->bundles[]
      //-->bundles[]
      //    -->bundle_name
      //    -->channels[]
      //        -->
      //    -->sub_bundle[]
      //        -->

    console.log(this.stringToFind)
    },


  },

  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.refresh()

    this.tempo = this.groupArborescence.length
 }

 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// FindElement.vue?3ed4d524